import styled from 'styled-components';
import Container from '../Container';
export const HighlightStyled = styled(Container).attrs({
    rounded: true,
})(({ theme, color, }) => {
    var _a, _b, _c, _d;
    return ({
        backgroundColor: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a[color]) === null || _b === void 0 ? void 0 : _b.light,
        overflow: 'hidden',
        padding: '16px',
        position: 'relative',
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '5px',
            backgroundColor: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c[color]) === null || _d === void 0 ? void 0 : _d.base,
        },
    });
});
//# sourceMappingURL=Highlight.styles.js.map